import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueSocketIO from "vue-socket.io";
import SocketIO from "socket.io-client";
import * as VueGoogleMaps from "vue2-google-maps";
import i18n from "./i18n";
import VueGeolocation from "vue-browser-geolocation";
import VueApexCharts from "vue-apexcharts";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueThreeSixty from "vue-360";
import JsonExcel from "vue-json-excel";

// vue-360 patch: $refs.viewport becomes null when component is unmounted while
// images are still loading (async race). Re-register with null guards.
function patchVue360(Vue) {
  const Original = Vue.component("vue-three-sixty");
  Vue.component("vue-three-sixty", {
    extends: Original,
    methods: {
      setImage(cached) {
        const self = this;
        this.currentLeftPosition = this.currentTopPosition = 0;
        if (!cached) {
          this.currentCanvasImage = new Image();
          this.currentCanvasImage.crossOrigin = "anonymous";
          this.currentCanvasImage.src = this.currentImage;
          this.currentCanvasImage.onload = function () {
            if (!self.$refs || !self.$refs.viewport) return;
            const vp = self.$refs.viewport.getBoundingClientRect();
            self.canvas.width = self.isFullScreen
              ? vp.width
              : self.currentCanvasImage.width;
            self.canvas.height = self.isFullScreen
              ? vp.height
              : self.currentCanvasImage.height;
            self.trackTransforms(self.ctx);
            self.redraw();
          };
          this.currentCanvasImage.onerror = function () {
            console.log("cannot load this image");
          };
        } else {
          this.currentCanvasImage = this.images[0];
          if (!this.$refs || !this.$refs.viewport) return;
          const vp = this.$refs.viewport.getBoundingClientRect();
          this.canvas.width = this.isFullScreen
            ? vp.width
            : this.currentCanvasImage.width;
          this.canvas.height = this.isFullScreen
            ? vp.height
            : this.currentCanvasImage.height;
          this.trackTransforms(this.ctx);
          this.redraw();
        }
      },
      updatePercentageInLoader(percentage) {
        if (this.$refs && this.$refs.viewPercentage) {
          this.$refs.viewPercentage.innerHTML = percentage + "%";
        }
      },
      resizeWindow() {
        if (!this.$refs || !this.$refs.viewport) return;
        this.setImage();
      },
    },
  });
}
import Notifications from "vue-notification";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueGauge from "vue-gauge";
Vue.component("VueGauge", VueGauge);
Vue.component("downloadExcel", JsonExcel);
import "vue-360/dist/css/style.css";
import "./registerServiceWorker";
import vueFlvPlayer from "vue-flv-player";
Vue.use(vueFlvPlayer);
Vue.use(Notifications);
Vue.use(VueThreeSixty);
patchVue360(Vue);
Vue.use(VueApexCharts);
Vue.use(DatePicker);
Vue.use(VueSweetalert2);
Vue.component("apexChart", VueApexCharts);
Vue.component("datePicker", DatePicker);
Vue.use(VueGeolocation);
Vue.use(
  new VueSocketIO({
    debug: false,
    connection: SocketIO(process.env.VUE_APP_SOCKET_URL),
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
  })
);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAPS_API_KEY,
    libraries: "places",
  },
});
Vue.config.productionTip = false;
new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
